import React from 'react';
import { connect } from 'react-redux';
import Nav from './Nav';
import SecondaryNav from './SecondaryNav';

/**
 * Header component to create the general layout structure for the headers
 */
export function Header(props) {
  return (
    <header aria-label="Top Navigation Bar">
      <nav className="nav__bar" aria-label="Primary">
        <Nav data-test="nav" />
        <div className="nav__logo-logout-block ">
          <SecondaryNav />
        </div>
      </nav>

      {/* <div className="header__lower-bar">
        <LanguageSelector data-test="language-selector" />
      </div> */}
    </header>
  );
}

export default connect()(Header);
